var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("header", { staticClass: "site-header" }, [
    _c(
      "button",
      {
        staticClass: "hamburger hamburger--htla",
        on: { click: _vm.toggleMenu }
      },
      [_c("span", [_vm._v("toggle menu")])]
    ),
    _vm._v(" "),
    _c("nav", { staticClass: "navbar navbar-expand-lg" }, [
      _c("a", { staticClass: "navbar-brand", attrs: { href: "#" } }, [
        _vm._v(
          "\n            " + _vm._s(_vm._.setting("APP_NAME")) + "\n        "
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "d-flex ml-auto collapse_ navbar-collapse_",
          attrs: { id: "main-nav" }
        },
        [
          _c("ul", { staticClass: "navbar-nav flex-row" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("li", { staticClass: "nav-item dropdown" }, [
              _c(
                "a",
                {
                  staticClass: "nav-link dropdown-toggle",
                  attrs: {
                    href: "#",
                    id: "navbarDropdownMenuLink",
                    "data-toggle": "dropdown",
                    "aria-haspopup": "true",
                    "aria-expanded": "false"
                  }
                },
                [
                  _c("span", { staticClass: "d-none d-sm-inline" }, [
                    _vm._v(_vm._s(_vm.user.name))
                  ]),
                  _vm._v(" "),
                  _c("i", { staticClass: "material-icons d-sm-none" }, [
                    _vm._v("account_circle")
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "dropdown-menu",
                  attrs: { "aria-labelledby": "navbarDropdownMenuLink" }
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "dropdown-item",
                      attrs: { href: _vm.userLink }
                    },
                    [_vm._v("Edit profile")]
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "dropdown-item",
                      attrs: { href: _vm.userLink + "#password" }
                    },
                    [_vm._v("Change password")]
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    { staticClass: "dropdown-item", on: { click: _vm.logout } },
                    [_vm._v("Logout")]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            !_vm._.isEmpty(_vm.connectionList)
              ? _c("li", { staticClass: "nav-item dropdown" }, [
                  _c(
                    "a",
                    {
                      staticClass: "nav-link dropdown-toggle",
                      attrs: {
                        href: "#",
                        id: "navbarDropdownMenuLink",
                        "data-toggle": "dropdown",
                        "aria-haspopup": "true",
                        "aria-expanded": "false"
                      }
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(_vm.connection.name) +
                          "\n                    "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "dropdown-menu",
                      attrs: { "aria-labelledby": "navbarDropdownMenuLink" }
                    },
                    _vm._l(_vm.connectionList, function(connection) {
                      return _c(
                        "a",
                        {
                          staticClass: "dropdown-item",
                          attrs: { href: connection.link + "#" + _vm.endpoint }
                        },
                        [_vm._v(_vm._s(connection.name))]
                      )
                    }),
                    0
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm._m(1)
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "nav-item active" }, [
      _c(
        "a",
        {
          staticClass: "nav-link",
          attrs: {
            href: "https://www.72dpi.co.nz/contact-us/",
            target: "_blank"
          }
        },
        [
          _c("i", { staticClass: "material-icons" }, [_vm._v("help_outline")]),
          _c("span", { staticClass: "d-none d-md-inline" }, [
            _vm._v(" Support")
          ])
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", { staticClass: "nav-item" }, [
      _c(
        "a",
        { staticClass: "nav-link", attrs: { href: "/", target: "_blank" } },
        [
          _c("span", { staticClass: "d-none d-md-inline" }, [
            _vm._v("Live site")
          ]),
          _vm._v(" "),
          _c("i", { staticClass: "material-icons" }, [_vm._v("arrow_forward")])
        ]
      )
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5c9faa77", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c9faa77","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/HeaderComponent.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-5c9faa77","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./seventytwo/72cms-ui/src/components/HeaderComponent.vue
// module chunks = 0